// @ts-nocheck
// tslint:disable
/**
 * PalmApp Server Web API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



// tslint:disable
import { APIModel, APIModelOptions, AttributeMapItem } from "../base";

export class ImageDto extends APIModel {
    /**
    * Image identifier
    */
    id: number;
    /**
    * Image type
    */
    type: string;
    /**
    * Filename
    */
    fileName: string;
    /**
    * File size
    */
    fileSize: number;
    /**
    * Date of creation
    */
    created: string;
    /**
    * Date of modification
    */
    lastModified: string;

    constructor(options?: APIModelOptions) {
        super(ImageDto.attributeTypeMap, options);
    }

    static get attributeTypeMap(): Array<AttributeMapItem> {
        return [
            { name: "id", type: "number" },
            { name: "type", type: "string" },
            { name: "fileName", type: "string" },
            { name: "fileSize", type: "number" },
            { name: "created", type: "string" },
            { name: "lastModified", type: "string" }
        ];
    }
}




